import { useEffect } from "react";
import PropTypes from "prop-types";
import "../assets/css/toast.css";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaInfoCircle,
} from "react-icons/fa";

const iconMap = {
  success: <FaCheckCircle className="toast__icon toast__icon--success" />,
  error: <FaExclamationCircle className="toast__icon toast__icon--error" />,
  info: <FaInfoCircle className="toast__icon toast__icon--info" />,
};

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast toast--${type}`}>
      {iconMap[type]}
      <span className="toast__message">{message}</span>
      <button
        className="toast__close"
        onClick={onClose}
      >
        &times;
      </button>
      <div className="toast__progress" />
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "info"]).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Toast;
